import React, { PropsWithChildren } from 'react';
import { COBannerVariant } from '@components/FigmaComponents/COBannerVariant.ts';
import clsx from 'clsx';

interface ComponentProps {
  variant: COBannerVariant;
  /** Node rather than string so a banner can emphasise part of its sentence, as the designs do. */
  label: React.ReactNode;
  className?: string;
}

const COBanner: React.FC<PropsWithChildren<ComponentProps>> = ({ variant, label, className }) => {
  return (
    <div className={clsx(
      'flex p-6 justify-center items-start gap-2 self-stretch',
      'font-dm-sans text-4.5 font-normal leading-normal text-content-primary',
      {
      'bg-complementary-infoLight': variant === COBannerVariant.Info,
      'bg-complementary-warningMedium': variant === COBannerVariant.Warning,
      'bg-complementary-errorMedium': variant === COBannerVariant.Error,
      'bg-complementary-successMedium': variant === COBannerVariant.Success,
      },
      className,
      )}>
      {label}
    </div>
  );
};

export default COBanner;
